import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Select,
  SelectProps,
} from '@chakra-ui/react'
import { Control, FieldValues, Path, useController } from 'react-hook-form'

export interface Option {
  value: string
  label: string
}

interface FormSelectProps<T extends FieldValues>
  extends Omit<SelectProps, 'name'> {
  name: Path<T>
  label: string
  control: Control<T, any, any>
  options: Option[]
  placeholder?: string
  isRequired?: boolean
}

export function FormSelect<T extends FieldValues>({
  name,
  label,
  control,
  options,
  placeholder = 'Selecione...',
  isRequired = false,
  ...selectProps
}: FormSelectProps<T>) {
  const {
    field,
    fieldState: { error },
  } = useController({
    name,
    control,
  })

  return (
    <FormControl isInvalid={!!error} isRequired={isRequired}>
      <FormLabel>{label}</FormLabel>
      <Select {...field} {...selectProps} placeholder={placeholder}>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </Select>
      <FormErrorMessage>{error?.message}</FormErrorMessage>
    </FormControl>
  )
}
